import ConfirmationModal from '~/components/ConfirmationModal';

const DeleteConfirmationModal = (props) => (
  <ConfirmationModal
    confirmButtonText="Delete anyway"
    confirmButtonLoadingText="Deleting..."
    {...props}
  />
);

export default DeleteConfirmationModal;
